// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"33":"css/print-pdf","170":"css/app","555":"css/article"}[chunkId] + ".css";
};